import { render } from "./OnboardingElectronicAddressPage.vue?vue&type=template&id=59fcf1d4&scoped=true"
import script from "./OnboardingElectronicAddressPage.vue?vue&type=script&lang=js"
export * from "./OnboardingElectronicAddressPage.vue?vue&type=script&lang=js"

import "./OnboardingElectronicAddressPage.vue?vue&type=style&index=0&id=59fcf1d4&lang=scss"
import "./OnboardingElectronicAddressPage.vue?vue&type=style&index=1&id=59fcf1d4&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59fcf1d4"]])

export default __exports__